import { Avatar, Typography, useMediaQuery, useTheme } from "@mui/material";
import { tpTheme } from "@trainingpeaks/designtokens";
import { useUserContext } from "@context/UserContext";

const UserAvatarIcon = () => {
  const { user } = useUserContext();
  const theme = useTheme();
  const isWide = useMediaQuery(theme.breakpoints.up("lg"));

  const userIcon = user?.personPhotoUrl ? (
    <Avatar className="h-6 w-6 mr-2 ml-2" src={user.personPhotoUrl} data-testid="user-avatar" />
  ) : (
    <div className="mr-2 ml-2 flex items-center" data-testid="user-icon">
      <Avatar
        className="border-2 border-solid w-6 h-6"
        style={{ borderColor: tpTheme.semanticLayer.colors.primary.main }}
      />
    </div>
  );

  return (
    <div className="flex items-center pr-4" data-testid="user-avatar-icon-component">
      {userIcon}
      {isWide && user && (
        <Typography color="white" variant="body2">
          {`${user.firstName} ${user.lastName}`}
        </Typography>
      )}
    </div>
  );
};

export default UserAvatarIcon;
